/*
 * GermanyKG — WhatsApp-Button (konfiguriert im CRM "Internetshop").
 * Eine Gruppe [data-gkg-wa-group] mit 1..n Buttons [data-gkg-wa]; je Button
 * eine Nachrichtenvorlage (data-template). Platzhalter {product} {size}
 * {size_ru} {url} {price} werden beim Laden/Groessenwechsel/Klick ersetzt.
 * Sichtbarkeit: ausgeblendet, wenn die gewaehlte Groesse im Vorbestell-Zustand
 * ist (Filial-Block zeigt .gkg-sa__soon) -> dann bleibt nur der Vorbestell-
 * Button. Tracking je Aktion: GA4 + Beacon ans CRM. Best-effort.
 */
(function () {
  var PROXY = '/apps/konto/api/events/wa-click';

  function anonId() {
    try {
      var k = 'gkg_anon', v = localStorage.getItem(k);
      if (!v) { v = 'a' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return null; }
  }

  function currentSize(section) {
    var vs = document.getElementById('variant-selects-' + section);
    if (!vs) return null;
    var checked = vs.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var sel = vs.querySelector('select');
    return sel ? sel.value : null;
  }

  function currentVariantId(section, size) {
    try {
      var vs = document.getElementById('variant-selects-' + section);
      if (!vs) return null;
      var data = JSON.parse(vs.querySelector('script[type="application/json"]').textContent);
      var v = data.find(function (x) { return x.option1 === size || (x.options && x.options.indexOf(size) >= 0); });
      return v ? String(v.id) : null;
    } catch (e) { return null; }
  }

  function fill(tpl, ctx) {
    return (tpl || '')
      .replace(/\{product\}/g, ctx.product)
      .replace(/\{size_ru\}/g, ctx.size ? ('размер ' + ctx.size) : '')
      .replace(/\{size\}/g, ctx.size || '')
      .replace(/\{url\}/g, ctx.url)
      .replace(/\{price\}/g, ctx.price || '')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/ +([.,:;!?])/g, '$1')
      .replace(/ *\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/[ \t]+$/gm, '')
      .trim();
  }

  function ctxFor(group) {
    var section = group.dataset.section;
    var isDefault = group.dataset.defaultVariant === 'true';
    var size = isDefault ? null : currentSize(section);
    var variantId = size ? currentVariantId(section, size) : null;
    var url = group.dataset.url + (variantId ? ('?variant=' + variantId) : '');
    return {
      product: group.dataset.product || '', size: size, url: url,
      price: group.dataset.price || '', variantId: variantId,
      handle: group.dataset.handle, productId: group.dataset.productId,
      number: group.dataset.number, section: section
    };
  }

  function build(group) {
    var ctx = ctxFor(group);
    group._ctx = ctx;
    group.querySelectorAll('[data-gkg-wa]').forEach(function (a) {
      a.href = 'https://wa.me/' + ctx.number + '?text=' + encodeURIComponent(fill(a.dataset.template, ctx));
    });
  }

  function syncVisibility(group, root) {
    var section = group.dataset.section;
    try {
      var soon = (root || document).querySelector('#StoreAvailability-' + section + ' .gkg-sa__soon');
      group.hidden = !!soon;
    } catch (e) { group.hidden = false; }
  }

  function track(group, a) {
    var ctx = group._ctx || ctxFor(group);
    var payload = {
      product_id: ctx.productId || null, handle: ctx.handle || null,
      variant_id: ctx.variantId || null, size: ctx.size || null,
      title: ctx.product || null, source: (a.dataset.key || 'product'),
      owner_id: anonId()
    };
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'whatsapp_click', {
          product_handle: payload.handle, size: payload.size,
          variant_id: payload.variant_id, product_id: payload.product_id, action: payload.source
        });
      } else if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({
          event: 'whatsapp_click', product_handle: payload.handle,
          size: payload.size, variant_id: payload.variant_id, action: payload.source
        });
      }
    } catch (e) {}
    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      if (navigator.sendBeacon) { navigator.sendBeacon(PROXY, blob); }
      else { fetch(PROXY, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }); }
    } catch (e) {}
  }

  function bindGroup(group) {
    if (group._gkgBound) return; group._gkgBound = true;
    build(group);
    syncVisibility(group, document);
    group.querySelectorAll('[data-gkg-wa]').forEach(function (a) {
      a.addEventListener('click', function () { build(group); track(group, a); });
    });
  }

  function init() {
    document.querySelectorAll('[data-gkg-wa-group]').forEach(bindGroup);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var sid = event && event.data && event.data.sectionId;
        var html = event && event.data && event.data.html;
        document.querySelectorAll('[data-gkg-wa-group]').forEach(function (g) {
          if (!sid || g.dataset.section === sid) { build(g); syncVisibility(g, html || document); }
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
